import type { ChangeFlightPage } from '@/app/common/starTrack/events/utils/starTrack.types';

export const FLIGHT_CHANGED = 'FLIGHT_CHANGED';
export const FLIGHT_CHANGED_VERSION = '1.1';

export type FlightChangedPayload = {
  searchId: string;
  productDetailKey: string;
  tripIdReplaced: string;
  tripIdSelected: string;
  outboundOriginHubId: string;
  outboundArrivalHubId: string;
  outboundStops: number;
  outboundTransportCompanyName: string;
  outboundTransportOperativeId: string;
  outboundOriginLocalTime: string;
  outboundArrivalLocalTime: string;
  inboundOriginHubId: string;
  inboundArrivalHubId: string;
  inboundStops: number;
  inboundTransportCompanyName: string;
  inboundTransportOperativeId: string;
  inboundOriginLocalTime: string;
  inboundArrivalLocalTime: string;
  flightsCost: number;
  page: ChangeFlightPage;
};

const getOperativeIds = (segments?: TransportSegment[]): string =>
  segments?.map((segment) => segment.transportNumber).join('#') || '';

export type FlightChangedParams = {
  searchId: string;
  productDetailKey: string;
  page: ChangeFlightPage;
  currentTransport: { id: string } | undefined;
  transportId: string;
  extendedSelectedTransport: AvailableTransport | undefined;
};

export const createFlightChangedPayload = (params: FlightChangedParams): FlightChangedPayload => {
  const { searchId, productDetailKey, page, currentTransport, transportId, extendedSelectedTransport } = params;

  const outboundStops = extendedSelectedTransport?.outbound?.segments?.length || 0;
  const inboundStops = extendedSelectedTransport?.inbound?.segments?.length || 0;

  return {
    searchId,
    productDetailKey,
    page,
    tripIdReplaced: currentTransport?.id || '',
    tripIdSelected: transportId,
    outboundOriginHubId: extendedSelectedTransport?.outbound?.segments?.[0]?.departureHub?.id || '',
    outboundArrivalHubId: extendedSelectedTransport?.outbound?.segments?.[outboundStops - 1]?.arrivalHub?.id || '',
    outboundStops,
    outboundTransportCompanyName: extendedSelectedTransport?.outbound?.segments?.[0]?.company?.name || '',
    outboundTransportOperativeId: getOperativeIds(extendedSelectedTransport?.outbound?.segments),
    outboundOriginLocalTime: extendedSelectedTransport?.outbound?.segments?.[0]?.departureDate || '',
    outboundArrivalLocalTime: extendedSelectedTransport?.outbound?.segments?.[outboundStops - 1]?.arrivalDate || '',
    inboundOriginHubId: extendedSelectedTransport?.inbound?.segments?.[0]?.departureHub?.id || '',
    inboundArrivalHubId: extendedSelectedTransport?.inbound?.segments?.[inboundStops - 1]?.arrivalHub?.id || '',
    inboundStops,
    inboundTransportCompanyName: extendedSelectedTransport?.inbound?.segments?.[0]?.company?.name || '',
    inboundTransportOperativeId: getOperativeIds(extendedSelectedTransport?.inbound?.segments),
    inboundOriginLocalTime: extendedSelectedTransport?.inbound?.segments?.[0]?.departureDate || '',
    inboundArrivalLocalTime: extendedSelectedTransport?.inbound?.segments?.[inboundStops - 1]?.arrivalDate || '',
    flightsCost: -1,
  };
};
